export enum USERS_KEYS {
  ALL = 'all-users',
  USER = 'user',
  USERS_LIST = 'users-list',
}
